import Mutations from '../../odata/mutations';

export default { ...new Mutations('currencies'), ...new Mutations('selectedCurrency') };
